<template>
    <!-- 第28批 插入需求，对账单号搜索改为客户列表 -->
    <div class="mt20"  v-loading.body="loading">
        <ly-table
            :head="customerConfig.head"
            :data="tableData" 
            :buttons="customerConfig.buttons"
            :config="customerConfig.config"
            :has-btn="true"
            @click="tableClick">
        </ly-table>
        <div class="tr mt10">
            <el-pagination
                layout="prev, pager, next"
                :page-size="formData.size"
                :current-page="formData.page"
                :total="total"
                @current-change="handlePage">
            </el-pagination>
        </div>
    </div>
</template>
<script>
    import LyTable from '@c/table'
    export default {
        props: {
            accountId: [String, Number], // 详情的accountId
            amount: [String, Number] // 流水详情的收支金额
        },
        components: {
            LyTable
        },
        data () {
            return {
                loading: false,
                total:0, // 总的条数
                tableData: [], // 表格的数据
                formData: {
                    account_id: 0,
                    page: 1,
                    size: 50,
                    status: 1,
                    sz_amount: 0
                }, // 查询客户信息的表单数据
                customerConfig: {
                    config: {
                        isNumber: true
                    },
                    buttons: [{
                        type: 'text', 
                        text: '确认对账',
                        mark: 'submitCustomer'
                    }],
                    head: [{
                            "prop": "transaction_no_display",
                            "label": "登记单号"
                        }, {
                            "prop": "work_time",
                            "label": "登记日期"
                        }, {
                            "prop": "huikuan_time",
                            "label": "回款日期"
                        }, {
                            "prop": "shoukuan_name",
                            "label": "收款账户"
                        }, {
                            "prop": "shoukuan_amount",
                            "label": "收款金额"
                        }, {
                            "prop": "customer_account",
                            "label": "客户编码"
                        }, {
                            "prop": "customer_name",
                            "label": "客户名称",
                            "head": [
                                {"prop":"customer_name","label":"客户名称"},
                                {"prop":"customer_account","label":"客户编码"},
                                {"prop":"customer_amount","label":"收款金额"},
                                {"prop":"shouxufei","label":"手续费"},
                                {"prop":"weidu_name","label":"核算纬度"},
                                {"prop":"remark","label":"备注"}
                            ]
                        }, {
                            "prop": "huikuan_amount",
                            "label": "客户回款金额",
                            "width": 220
                        }, {
                            "prop": "dengjiren",
                            "label": "登记人"
                        }, {
                            "prop": "zhaiyao",
                            "label": "摘要"
                        }
                    ]
                }, // 客户列表信息的配置
                changeData: {} // 选中提交的客户信息
            }
        },
        created () {
            this.formData.account_id = this.accountId
            this.formData.sz_amount = this.amount
            this.queryData()
        },
        methods: {
            queryData () {
                this.loading = true
                this.$api.query('api/paycheckin', this.formData).then((rs) => {
                    this.total = rs.total
                    this.tableData = rs.data
                    this.loading = false
                }).catch(() => {
                    this.tableData = []
                    this.loading = false
                })
            },
            /**
             * 表格行按钮的点击
             */
            tableClick (mark, index, row) {
                this.changeData = row
                this.$emit('change')
            },
            /**
             * 分页
             * @param  {[type]} val [description]
             * @return {[type]}     [description]
             */
            handlePage (val) {
                this.formData.page = val
                this.queryData()
            },
            /**
             * 数据验证
             */
            validate () {
                if (this.changeData.transaction_no_display && this.changeData.transaction_no_display.length > 0) {
                    return true
                } else {
                    this.$message({
                        message: '未选择回款登记单，请选择后进行提交！',
                        type: 'warning'
                    })
                    return false
                }
            },
            /**
             * 获得数据
             */
            getData () {
                return {
                    huikuang_transaction_no_display: this.changeData.transaction_no_display
                }
            }
        }
    }
</script>